<template>
  <div>
    <el-dialog
      title="批量导入"
      append-to-body
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="600px"
      :before-close="handleClose1"
      accept="vnd.ms-excel"
    >
      <el-form :model="form" ref="formRef" :rules="formRules"  label-width="120px">
        <el-form-item label="数据上传：" prop="importFileList">

          
          <el-upload
            class="upload-demo"
            drag
            :file-list="form.importFileList"
            :http-request="httpRequest"
            :before-upload="beforeUpload"
            :before-remove="beforeRemove"
            :multiple="false"
            accept=".xls,.xlsx"
            :limit="1"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">请上传 .xls,.xlsx 标准格式文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="模板下载：" >
          <el-row>
            <el-col>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-download"
                @click="exportDemoExcel"
              >
                下载模板
              </el-button>
              <el-radio-group
                v-model="exportExcelType"
                style="margin-left: 10px; dislay: flex; align-items: center;"
              >
                <el-radio :label="1">只导出表头模板</el-radio>
                <el-radio :label="2">导出含物料信息的模板</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </el-form-item>
        <div style=" text-align: right;">
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="saveRecord"
            size="small"
          >
            提交
          </el-button>
          <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
            取消
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/util/request';
import { getToken } from '@/util/auth';
export default {
  components: {},
  props: {
    submitApi: {},
    export1Api: {},
    export2Api: {},
    visible: {
      type: Boolean,
      default: false,
    },
    flag:{
      type: Boolean,
      default: false,
    },
    projectId: {},
  },
  data() {
    return {
      // 导入的文件列表
     
      form: {
        importFileList: [],
      },
      formRules: {
        importFileList: [{ required: true, message: '文件不能为空', trigger: 'change' }],
      
      },
      // 导出的模板类型
      exportExcelType: 1,
    };
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    handleClose1() {
      this.$confirm(' 是否关闭继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$emit('update:visible', false);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    exportDemoExcel() {
      this.$confirm('是否导出模板数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let apiStr = '';
        if (this.exportExcelType == 1) {
          apiStr = this.export1Api;
        } else {
          apiStr = this.export2Api;
        }
        console.log(apiStr);
        window.open(
          `${apiStr}?${this.website.tokenHeader}=${getToken()}&projectId=${this.projectId}`
        );
      });
    },

    /* 上传完模板 */
    afterImportFile(file) {
      let fd = new FormData();
      fd.append('file', file.file);
      fd.append('projectId', this.projectId);
    
      
      request
        .post(this.submitApi, fd)
        .then((res) => {
          this.$message.success('导入成功！');
          this.importFileList = [];
          this.$emit('success', res);
        })
        .catch(() => {
          this.importFileList = [];
        });
    },
    saveRecord(){
      this.$refs['formRef'].validate((valid) => {
       if(valid){
        let fd = new FormData();
      fd.append('file', this.form.importFileList[0]);
      fd.append('projectId', this.projectId);
      fd.append('flag', this.flag);
      request
        .post(this.submitApi, fd)
        .then((res) => {
          this.$message.success('导入成功！');
          this.form.importFileList = [];
          this.$emit('success', res);
        })
        .catch(() => {
          this.form.importFileList = [];
          this.$message.error();('导入失败！');
        });
       }
      });
    },
    httpRequest(){},
    beforeUpload(file){
      this.form.importFileList.push(file)
    },
    beforeRemove(file){
       let deleteIndex;
      this.form.importFileList.forEach((item, index) => {
        if (item == file) {
          deleteIndex = index;
        }
      });
      if (deleteIndex !== undefined) {
        this.form.importFileList.splice(deleteIndex, 1);
      }
    
    },
    cancleRecord(){
      this.$emit('update:visible', false);
    }
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
</style>
